<template>
    <Head :title="`Manage ${role.name} Role`" />

    <AuthenticatedLayout>
        <template #header>
            <NavigationSettings />
        </template>

        <div class="py-8 max-w-7xl mx-auto grid gap-4 grid-cols-6">


            <form @submit.prevent="save"
                class="col-span-6 p-6 bg-white border border-gray-200 sm:rounded-lg">

                <h3 class="font-semibold text-xl text-gray-800 sm:leading-tight my-auto">
                    Manage {{role.name}} Role
                </h3>

                <div class="mt-4">
                    <Label>Name</Label>
                    <Input v-model="role.name"
                        class="w-1/3" />
                    <InputError :message="this.$attrs.errors.name"/>
                </div>

                <div class="mt-2">
                    <Label>Comment</Label>
                    <Input v-model="role.comment"
                        class="w-full"/>
                </div>

                <div class="mt-8 grid grid-cols-6 gap-4" v-if="role.id !== 1">
                    <div v-for="(item, namespace) in attributes">
                        <strong class="capitalize">{{ namespace.replace(/_/g, ' ') }}</strong>
                        <label v-for="name in item"
                               class="flex items-center mt-2">
                            <Checkbox v-model:checked="permissions[namespace][name]"/>
                            <span class="ml-2 text-sm text-gray-600 capitalize">{{ name.replace(/_/g, ' ') }}</span>
                        </label>
                    </div>
                </div>

                <div class="mt-12 flex gap-4">
                    <ButtonSecondary :href="route('settings.roles.index')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
                        </svg>
                        <span class="ml-2">
                            Back to Roles
                        </span>
                    </ButtonSecondary>
                    <Button>
                        Save
                    </Button>
                </div>

            </form>
        </div>
    </AuthenticatedLayout>
</template>


<script>
import moment from 'moment';
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import Button from "@/Components/Button";
import ButtonSecondary from "@/Components/ButtonSecondary";
import Label from "@/Components/Label";
import Input from "@/Components/Input";
import InputError from "@/Components/InputError";
import Checkbox from "@/Components/Checkbox";

export default {
    components: {
        Head,
        Link,
        AuthenticatedLayout,
        NavigationSettings,
        Button,
        ButtonSecondary,
        Label,
        Input,
        InputError,
        Checkbox,
    },
    props: {
        role: Object,
        attributes: Object,
        permissions: Object,
    },
    methods: {
        moment,
        save() {
            this.$inertia.patch(route('settings.roles.update', this.role.id), {
                name: this.$props.role.name,
                comment: this.$props.role.comment,
                permissions: this.$props.permissions
            })
        },
    },
}
</script>
